import React, { useState, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/esm/Button';
import FormCustom from '../../Components/Form/FormCustom';
import Input from '../../Components/Form/Input';

const SaleTotalBranchOffice = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [totales, setTotales] = useState({
        total_mxn: 0,
        total_usd: 0
    })

    const [dataFilter, setDataFilter] = useState({
        p_date_start: '',
        p_date_end: ''
    })

    const [reporte, setReport] = useState({})

    const getData = _ => {
        setIsProccesing(true)
        Controllers.sale.get_sale_total({
            ...dataFilter
        }).then(res => {
            setRows(res.data.records)
            setTotales({
                total_mxn: res.data.total_mxn,
                total_usd: res.data.total_usd,
            })
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                {
                    name: 'name_branch_office', text: 'Sucursal', align: 'center'
                },
                { name: 'total', text: 'Total Neto', align: 'center' },
                { name: 'iva', text: 'IVA', align: 'center' },
                { name: 'total_mxn', text: 'Total MX', align: 'center' },
                { name: 'total_usd', text: 'Total DLL', align: 'center' },
                { name: 'code_period', text: 'Periódo', align: 'center' },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Ventas Totales por Sucursal</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
                    getData()
                }}>
                    <Input
                        classNameParent="col-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Inicio"
                        text="Fecha Inicio"
                        onChange={e => setDataFilter({ ...dataFilter, p_date_start: e.currentTarget.value })}
                        required
                        type="date"
                    />
                    <Input
                        classNameParent="col-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Fina"
                        text="Fecha Fina"
                        onChange={e => setDataFilter({ ...dataFilter, p_date_end: e.currentTarget.value })}
                        append={[<Button type="submit">
                            <i className="fa fa-search mr-2"></i>Buscar
                        </Button>]}
                        required
                        type="date"
                    />
                </FormCustom>
                {reporte?.filename ? <div className='mb-4'>
                    <a href={reporte?.excel} download={reporte?.filename}>
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                        </Button>
                    </a>
                </div> : ''}
                {dtRows}
            </Card.Body>
        </Card>
        {!isProcessing && <div className="d-flex justify-content-center mt-4">
            <div className="alert alert-success text-center">
                <h5>Total MXN: <strong>{totales.total_mxn}</strong></h5>
                <h5>Total USD: <strong>{totales.total_usd}</strong></h5>
            </div>
        </div>}
    </>
}

export default SaleTotalBranchOffice